import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { useFormik } from "formik";
import * as Yup from "yup";
import { classNames } from "primereact/utils";
import { CounterString } from "../../componentes/CounterString";
import { limitSize } from "../../constantes/appConstantes";

const ModalObservacion = ({ modal, toggleModal, callbackArchive, codSolicitud }) => {
  const validationSchema = Yup.object().shape({
    observacionRechazo: Yup.string().required("Campo requerido."),
  });

  const formik = useFormik({
    initialValues: {
      codSolicitud: codSolicitud,
      observacionRechazo: "",
    },
    validationSchema: validationSchema,
    onSubmit: (data) => {
      callbackArchive(data);
    },
  });

  const getFormErrorMessage = (name) => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
  };

  const isFormFieldValid = (name) => {
    const isValid = !!(formik.touched[name] && formik.errors[name]);
    return isValid;
  };

  return (
    <Dialog
      visible={modal}
      header="Agregar el motivo para archivar la solicitud"
      modal
      footer={
        <div>
          <Button
            label="Cancelar"
            icon="pi pi-times"
            type="button"
            onClick={() => toggleModal()}
            className="p-button-secondary"
          />
          <Button
            label="Guardar"
            icon="pi pi-save"
            type="button"
            onClick={formik.handleSubmit}
            className="p-button-primary"
          />
        </div>
      }
      onHide={() => toggleModal()}
    >
      <div className="flex col-12 md:col-12">
        <div className="col">
          <InputTextarea
            id="observacionRechazo"
            name="observacionRechazo"
            rows={5}
            maxLength={limitSize.TEXT_INPUT_1000}
            value={formik.values.observacionRechazo}
            autoComplete="off"
            className={classNames({
              "p-invalid": isFormFieldValid("observacionRechazo"),
            })}
            onChange={formik.handleChange}
            style={{ width: "100%" }}
          />
          {getFormErrorMessage("observacionRechazo")}
          <CounterString
            length={formik.values.observacionRechazo.length}
            maxLength={limitSize.TEXT_INPUT_1000}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default ModalObservacion;
